import { PageMeta } from '../components/PageMeta';
import { Btn } from '../site/primitives';
import { AstronautArt, Hero } from '../site/sections';
import { ART } from '../site/media';

export const DEFAULT_BOOKING_URL = 'https://calendar.app.google/JJtE7LpQDK3RwD8j9';
export const bookingUrl = import.meta.env.VITE_BOOKING_URL?.trim() || DEFAULT_BOOKING_URL;

export function BookCallPage() {
  return <>
    <PageMeta title="Book a Call" description="Choose a time for a short introductory call with Enshield." />
    <Hero compact titleId="book-call-title" eyebrow="Book an Intro Call" title={<>Let’s find a time that works.</>} lead="Choose an available 15-minute time to learn how Enshield can support your business." actions={<Btn href={bookingUrl}>View available times</Btn>} art={<AstronautArt {...ART.operations} support priority className="astra-support-guide" />} />
  </>;
}
